import { find, path, propEq, pipe } from 'ramda';

export const findPiLabel = (labels, indicator) => pipe(find(propEq('indicator', indicator)), path(['label']))(labels);
